/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';

const hrefProp = createPropDefinition('href', '', normalizeString, (v) => typeof v === 'string', { required: true });

export { hrefProp as h };
//# sourceMappingURL=href-B7u09W3s.js.map

//# sourceMappingURL=href-B7u09W3s.js.map